import type { LinkableDlnItemsLookupParams } from './types';

import { type QueryFunctionContext, queryOptions } from '@tanstack/react-query';
import { ms } from 'ms';

import { queryKeysInvoice } from '../queryKeys';

import { fetchLinkableDlnItemsSelection } from './fetchLinkableDlnItemsSelection';

/**
 * Generates query options for every delivery note line the article search
 * matches, as link targets. A failure is left to the caller; nothing is
 * toasted.
 *
 * @param params - Invoice, line item and the search filters.
 * @returns Query options.
 */
export function getLinkableDlnItemsSelectionQueryOptions(
  params: LinkableDlnItemsLookupParams,
) {
  return queryOptions({
    meta: { suppressError: true },
    queryFn: ({ signal }: QueryFunctionContext) =>
      fetchLinkableDlnItemsSelection(params, { signal }),
    queryKey: queryKeysInvoice.getLinkableDlnItemsSelection(params),
    staleTime: ms('30s'),
    throwOnError: false,
  });
}
